module.exports = "<div users-wrapper page-class=\"users-start-page\">\n  <div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <p><div logo></div></p>\n    <h1>{{ \"USERS.START.TITLE\" | translate }}</h1>\n    \n    <p><a class=\"md-button md-raised md-primary\" ui-sref=\"public.users.login\">\n      {{ \"USERS.START.GO_TO_LOGIN\" | translate }}\n    </a></p>\n\n    <p>{{ \"USERS.START.TYPE_CLIENT\" | translate }}</p>\n    <p><a ui-sref=\"public.users.client.client-registration\">{{ \"USERS.START.REGISTER_BUTTON\" | translate }}</a></p>\n  </div>\n  <div policy></div>\n</div>\n\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/users/start.html
// module id = 266
// module chunks = 0